


































import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';
import { PropType } from 'vue';
import { ValidatorProps } from 'types/validator';
import { ValidationProvider } from 'vee-validate';

export const emptyValue: string = null;

export default mixins(E2EMixin).extend({
  components: {
    ValidationProvider,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array as () => Option[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '選択してください',
    },
    defaultValue: {
      type: String,
      default: emptyValue,
    },
    value: {
      type: String,
      default: emptyValue,
    },
    required: {
      type: Boolean,
      default: true,
    },
    validator: {
      type: Object as PropType<ValidatorProps>,
      default: () => ({ name: undefined, rules: undefined }),
    },
  },
  computed: {
    innerOptions(): Option[] {
      return this.required
        ? this.options
        : this.options.map(
            (option): Option => {
              if (option.value !== emptyValue) return option;
              // make it selectable
              const opt = Object.assign({}, option);
              opt.disabled = false;
              return opt;
            }
          );
    },
  },
  methods: {
    handleInput(e) {
      const v = e.target.value;
      this.$emit('input', v === '' ? emptyValue : v);
    },
    async handleBlur() {
      const provider = this.$refs.provider as InstanceType<
        typeof ValidationProvider
      >;
      await provider.validate();
    },
  },
});
